import styles from "./Infocard.module.css";
import chevrondown from "../../assets/Icons/chevron-down.svg";

export default function Infocard({content,position}) {
  return (
    
    <div className={`${styles.infocard}  ${styles[position]}`}>
      <div className={styles.container}>
        {content.map((element)=>(
         <li>{element}</li>
        ))}          
      </div>
      <img src={chevrondown} className={styles.chevronimg} />
    </div>  
  )
}
